new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        banners: {
            bandCommuniqueDropdown: false,
        },
        mobile: (window.innerWidth > 991) ? false : true,
        tabletPortrait: (window.innerWidth > 767) ? true : false,
    },
    created() {
        window.addEventListener("resize", this.screenHandler);
    },
    mounted() {
        this.secondBlock = true;
    },
    destroyed() {
        window.removeEventListener("resize", this.screenHandler);
    },
    methods: {
        screenHandler() {
            this.mobile = (window.innerWidth > 991) ? false : true;
            this.tabletPortrait = (window.innerWidth > 767) ? true : false;
        }
    }
})

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        //fade: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    $('#product_list').slick({
        arrows: false,
        dots: true,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,

        responsive: [
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    arrows: true,
                    dots: false
                }
            }
        ]
    }).on('afterChange', function(event, slick, currentSlide, nextSlide){
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function(element) {
                setTimeout(function(){
                    var parent = element.previousElementSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                }, 200);
            }
        });
    });

    $('#product_list-2').slick({
        arrows: false,
        dots: true,
        infinite: true,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,

        responsive: [
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    arrows: true,
                    dots: false
                }
            }
        ]
    }).on('afterChange', function(event, slick, currentSlide, nextSlide){
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function(element) {
                setTimeout(function(){
                    var parent = element.previousElementSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                }, 200);
            }
        });
    });

    $('#brands-carousel').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        mobileFirst: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 700,

        responsive: [
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 6,
                }
            },
            {
                breakpoint: 1150,
                settings: {
                    slidesToShow: 7,
                }
            },
            {
                breakpoint: 1250,
                settings: {
                    slidesToShow: 8,
                }
            }
        ]
    });

    $('.widget-category__photos').slick({
        arrows: false,
        dots: true,
        infinite: true,
        autoplay: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,

        responsive: [
            {
                breakpoint: 577,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    dots: true,
                    slidesToShow: 5,
                }
            }
        ]
    });

    $('.product-ratings__list').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,
        prevArrow: $('.product-ratings__list--item-footer-prev'),
        nextArrow: $('.product-ratings__list--item-footer-next'),
    });
})